import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAvocado = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
    <mask
      id="avocado_svg__a"
      width={357}
      height={357}
      x={-60}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path
        fill="#fff"
        d="M296.25 178.2c0 98.417-79.581 178.2-177.75 178.2S-59.25 276.617-59.25 178.2 20.331 0 118.5 0s177.75 79.783 177.75 178.2m-237 0c0 32.806 26.527 59.4 59.25 59.4s59.25-26.594 59.25-59.4-26.527-59.4-59.25-59.4-59.25 26.594-59.25 59.4"
      />
    </mask>
    <g mask="url(#avocado_svg__a)">
      <ellipse cx={118.5} cy={178.2} fill="#34AC68" rx={118.5} ry={118.8} />
      <ellipse cx={118.5} cy={77.22} fill="#34AC68" rx={77.025} ry={77.22} />
      <ellipse cx={118.5} cy={178.2} fill="#fff" rx={59.25} ry={59.4} />
      <path
        fill="#34AC68"
        d="M213.3 106.92c-14.22-21.384-18.367-47.52-23.7-59.4v59.4zm-189.6 0c14.22-21.384 18.368-47.52 23.7-59.4v59.4z"
      />
    </g>
  </svg>
);
export default SvgAvocado;
